import React, { useEffect, useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Carousel from "react-bootstrap/Carousel";
import { useNavigate } from "react-router-dom";
import slide1st from "../../Assets/images/Carousel1x.jpg";
import axios from "axios";
import { apiBaseURL } from "../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

const Home = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );
  const [cart, setCart] = useState([]);
  const store = useSelector((state) => state);

  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  const handleCart = (id) => {
    if (store?.userData?.accessToken === localStorage.getItem("token")) {
    } else {
      id.quantity = 1;
      localStorage.setItem("cartItems", JSON.stringify([...cart, id]));
      setCart([...cart, id]);
      const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
        (items) => items._id
      );
      setAdded(updatedArray);
      localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
      toast.info("Product Added", {
        position: "top-right",
        autoClose: 100,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
      navigate("/");
    }
  };
  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getAllProduct/?limit=3`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
      }
    } catch (e) {
      console.log("error", e.message);
      toast.error(e.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <ToastContainer />
      <div className="home_slider mb-0 ">
        <Carousel>
          <Carousel.Item>
            <img className="d-block w-100" src={slide1st} alt="First slide" />
            <div className="container">
              <div className="shop_window_btn">
                <Carousel.Caption>
                  <h3>Stay connected with the latest Windows OS.</h3>
                  <button
                    onClick={() => navigate("/category/WindowsOperatingSystem")}
                  >
                    Shop Windows OS
                  </button>
                </Carousel.Caption>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="main pt-4 pb-5">
        <div className="breadcrum">
          <Container>
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
            </Breadcrumb>
          </Container>
        </div>

        <div className="home_main_content">
          <Container>
            <div className="home_who_we_are box_shadow white_bg align_center">
              <h3>Our customers are the foundation of who we are</h3>
              <p className="mb-0 mx-0">
                We understand the marketplace is full of choices so we've made
                it our goal to provide you with everything you need to feel
                confident making Liberty Software yours.
                <br className="break_tag" />
                Our team of certified Mircosoft experts work hard to make your
                business needs just a click away and provide you with all your
                genuine Microsoft Software needs.
              </p>
            </div>
            <div className="mt-5">
              <Row>
                <Col xxl="3" lg="3" md="12">
                  <div className="home_have_questions box_shadow mb-4 white_bg align_center">
                    <h3>Have Questions?</h3>
                    <p className="mb-0">
                      Call +1 (833) 465 0300 <br /> or contact us via chat
                    </p>
                  </div>
                  <div className="home_modren_sol box_shadow mb-4 white_bg align_center">
                    <h3>
                      Providing modern solutions to move your business forward
                    </h3>
                    <p>
                      Our team works around the clock to help you make the right
                      steps to future-proof your business.
                    </p>
                    <p>
                      Adopt tech solutions that would best suit your
                      organizations capabilities by using the right combination
                      of Micrsoft software for both corporate and individual
                      needs.
                    </p>
                    <p>
                      Liberty Programs will help you recieve streamlined paths
                      to resources ready to help you combat the front lines of
                      innovation.
                    </p>
                  </div>
                </Col>
                <Col xxl="9" lg="9" md="12">
                  <Row>
                    {tableData.map((product, index) => {
                      return (
                        <Col xxl="4" lg="4" md="4" sm="12">
                          <div
                            className="box_shadow product_col container_box"
                            key={index}
                          >
                            <div className="Prod_img_container home_cardimg_container  mb-3">
                              <img
                                src={`${product.productImage}`}
                                alt="product"
                                className="product_image home_cardimg_container mb-5 w-100 word-wrap"
                                onClick={() =>
                                  navigate(
                                    `/product/${product.name.replace(
                                      /\s+/g,
                                      ""
                                    )}`
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </div>

                            <div>
                              <div>
                                <div>
                                  <h3 className="product_name m-0 mt-2">
                                    {product.name}
                                  </h3>
                                </div>
                                <p className="mb-0">
                                  Retail Version | <br className="card_break" />
                                  {product?.retailVersion[0]
                                    ?.split(":")
                                    .join(": ")}
                                </p>
                                <p className="mb-2">
                                  Includes: <br className="card_break" />{" "}
                                  Download + License Key
                                </p>
                              </div>
                              <p className="product_price ">
                                Price: <br />
                                {product.price > 0 ? (
                                  <span className="discounted_price">
                                    ${product.price}USD
                                  </span>
                                ) : (
                                  ""
                                )}
                                <span>${product.salePrice} USD</span>
                              </p>
                              {added.includes(product._id) ? (
                                <button
                                  className="add_cart_btn"
                                  onClick={() => navigate("/cart")}
                                >
                                  Go To Cart
                                </button>
                              ) : (
                                <button
                                  className="add_cart_btn"
                                  onClick={() => handleCart(product)}
                                >
                                  Add To Cart
                                </button>
                              )}

                              <button
                                className="view_product_btn"
                                onClick={() =>
                                  navigate(
                                    `/product/${product.name.replace(
                                      /\s+/g,
                                      ""
                                    )}`
                                  )
                                }
                              >
                                View Product
                              </button>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Home;
